<template>

  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">

      <div class="row w-100">
            <div class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
                نام سالن
              </label>
              <input v-model="formData.name" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>


            <div  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                شماره تماس ثبت کننده
              </label>
              <input v-model="formData.mobile" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

            <div class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                وضعیت
              </label>
              <multiselect
               v-model="status"
               :options="statusPlayer"
               placeholder=''
               label="title"
               track-by="title"
               :show-labels="false"
               :allow-empty="false"
               class="col-lg-8"
               >
               </multiselect>
            </div>

            <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100">
                <div class="row p-pay-representation-time-select w-100">
                    <div class="p-pay-representation-time-item">
                      <startEndSelectTime text-time="تاریخ ثبت از" check-start-end-time-status="start" @selectedDate="selectedDate"></startEndSelectTime>
                    </div>
                    <div class="mr-5 p-pay-representation-time-item">
                      <startEndSelectTime text-time="تاریخ ثبت تا" check-start-end-time-status="end" @selectedDate="selectedDate"></startEndSelectTime>
                    </div>
                </div>
            </div>

      </div>

      <div class="mt-4 flex-column justify-content-center w-100 p-list-salon-owner-export-btns d-flex flex-lg-row ">
              <button @click="searchData" type="button" class="btn-table p-list-representation-btn btn btn-primary btn-sm mb-lg-0 mb-3">
                جستجو
              </button>
      </div>


    </form>

  </div>

</template>

<script>
import startEndSelectTime from './startEndSelectTime';


export default {
  name: 'formData',
  components: {
    startEndSelectTime,
  },

  props: {
    statusPlayer        : {type:[Array,Object],default:[]},
    formDataOriginal    : {type:[Array,Object],default:[]},

  },

  data() {
    return {
      formData    : {

      },
      status      : {},


    }
  },

  computed: {

  },

  watch: {
    status(data){
      this.formData.content_approval = data.id;
    },

  },

  mounted () {
    this.formData = this.formDataOriginal;
  },

  methods: {
    entryPaySalons() {
      this.$emit('entryPaySalons');
    },

    selectedDate(data){
      if (data.status == 'start') {
        this.formData.from_date = data.date;
      }
      else {
        this.formData.to_date   = data.date;
      }
    },

    searchData(){
      this.$emit('searchData',this.formData)
    },

  },

}
</script>
